import AboutProjectLayout from './AboutProjectLayout';

export default AboutProjectLayout;
